<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M1.5,4.77v14.46h21V4.77H1.5ZM0,20.73h24V3.27H0v17.46Z" fill="currentColor" fill-rule="evenodd" />
    <path
      d="M12.15,15.79L1.26,4.89l1.06-1.06,9.83,9.84L21.98,3.83l1.06,1.06-10.89,10.9Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
